var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81221 6.94703L8.23259 4.25861C7.92384 3.73314 7.25386 3.55361 6.75259 3.90026C5.76631 4.58232 4.29637 5.77886 3.9307 7.05816C3.36307 9.04403 5.40933 13.7734 8.19136 16.5555C10.9735 19.3376 15.4616 21.1424 17.4475 20.575C18.7268 20.2095 19.9236 18.7402 20.6059 17.7541C20.9528 17.2528 20.7733 16.5826 20.2477 16.2738L17.5592 14.6942C17.0492 14.3945 16.3941 14.5425 16.0624 15.0323L15.3233 16.1237C15.0035 16.596 14.3825 16.7476 13.9047 16.436C13.135 15.9342 11.937 15.0645 10.6891 13.8166C9.44136 12.5688 8.57176 11.371 8.06989 10.6013C7.75822 10.1234 7.90994 9.50224 8.38254 9.18245L9.47378 8.44403C9.96382 8.11243 10.112 7.45718 9.81221 6.94703Z",
    stroke: "#9C2D56",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.bc576c6d959412ee58035b7e98cbe6c0.svg";
export { ForwardRef as ReactComponent };